import {  createSlice } from "@reduxjs/toolkit";

export const initialVendorForm={
    preschool_id: "",
    name:"",
    type:"",
    tags: [],
    mobile_number:"",
    email_address:"",
    gstin:"",
    address:"",
    account_number:"",
    bank:"",
    ifsc_code:"",
    upi_id:"",
}

export const initialEditVendorForm={
    name:"",
    type:"",
    tags: [],
    mobile_number:"",
    email_address:"",
    gstin:"",
    address:"",
    account_number:"",
    bank:"",
    ifsc_code:"",
    upi_id:"",
}

const initialState={
    popup: {
        addVendorPopup: false,
        editVendorPopup: false,
        deleteVendorPopup: false,
    },
    form: {
        addVendorForm: initialVendorForm,
        addVendorComponent: 1,
        editVendorComponent: 1,
        editVendorForm: initialEditVendorForm,
        deleteForm:null
    }
}

const addVendor = createSlice({
    name: 'addVendor',
    initialState,
    reducers: {
        addVendorForm:(state, action)=>{
            state.form.addVendorForm=action.payload
        },
        editVendorForm:(state, action)=>{
            state.form.editVendorForm=action.payload
        },
        addVendorComponent:(state, action)=>{
            state.form.addVendorComponent=action.payload
        },
        editVendorComponent:(state, action)=>{
            state.form.editVendorComponent=action.payload
        },
        openAddVendorPopup:(state)=>{
            state.popup.addVendorPopup=true
        },
        closeAddVendorPopup:(state)=>{
            state.popup.addVendorPopup=false
        },
        openEditVendorPopup:(state, action)=>{
            state.popup.editVendorPopup=true
            state.form.editVendorForm=action.payload
        },
        closeEditVendorPopup:(state)=>{
            state.popup.editVendorPopup=false
            state.form.editVendorForm=initialEditVendorForm
        },
        openDeleteVendorPopup:(state,action)=>{
            state.popup.deleteVendorPopup=true
            state.form.deleteForm=action.payload
        },
        closeDeleteVendorPopup:(state)=>{
            state.popup.deleteVendorPopup=false
            state.form.deleteForm=null
        },
    }
});

export const {addVendorForm, openAddVendorPopup, closeAddVendorPopup,
openEditVendorPopup, closeEditVendorPopup, openDeleteVendorPopup,
closeDeleteVendorPopup, addVendorComponent, editVendorComponent, editVendorForm}=addVendor.actions

// get state for popup
export const getAddVendorPopup = (state) => state.addVendor.popup.addVendorPopup
export const getEditVendorPopup = (state) => state.addVendor.popup.editVendorPopup
export const getDeleteVendorPopup = (state) => state.addVendor.popup.deleteVendorPopup

// get state for form and component
export const getAddVendorForm = (state) => state.addVendor.form.addVendorForm
export const getDeleteForm = (state) => state.addVendor.form.deleteForm
export const getEditVendorForm = (state) => state.addVendor.form.editVendorForm
export const getAddVendorComponent = (state) => state.addVendor.form.addVendorComponent
export const getEditVendorComponent = (state) => state.addVendor.form.editVendorComponent

export default addVendor.reducer